<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :disabled="disabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          :color="!disabled ? 'indigo white--text' : 'indigo lighten-4 white--text'"
          readonly
          v-bind="attrs"
          v-on="on"
      >{{monthNames[new Date(dateStart).getMonth()]}} 
      {{new Date(dateStart).getFullYear()}} 
      ~ {{monthNames[new Date(dateEnd).getMonth()]}}
      {{new Date(dateEnd).getFullYear()}} 
      </v-btn>
    </template>
    <v-card>
      <v-date-picker
          v-model="pickerDateStart"
          type="month"
          show-current="false"
          :picker-date.sync="pickerDateStart"
          :allowed-dates="allowedMonthsStart"
      ></v-date-picker>
      <v-date-picker
          v-model="pickerDateEnd"
          type="month"
          show-current="false"
          :picker-date.sync="pickerDateEnd"
          :allowed-dates="allowedMonthsEnd"
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="click"
          class="ml-auto"
        >
          Apply
        </v-btn>
      </v-date-picker>
    </v-card>
  </v-menu>
</template>

<script>

export default {
    props: {
      start: {
        type: String
      },
      end: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
    return {
      menu1: false,
      menu: false,
      dateStart: this.start,
      dateEnd: this.end,
      pickerDateStart: new Date(this.start).toISOString().substr(0, 7),
      pickerDateEnd: new Date().toISOString().substr(0, 7),
      monthNames: ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"]
    }
  },
  watch: {
    dateStart(){
      this.dateStart = this.start
    },
    dateEnd(){
      this.dateEnd = this.end
    },
      disabled: {
        type: Boolean,
        default: false
      }
  },
  methods: {
      click() {
        this.dateStart = new Date(this.pickerDateStart).toISOString().substr(0, 10);
        this.dateEnd = new Date(new Date(this.pickerDateEnd).getFullYear(), 
                                        new Date(this.pickerDateEnd).getMonth() + 1,
                                        new Date(this.pickerDateEnd).getDate()
                                        ).toISOString().substr(0, 10)

        sessionStorage.setItem('monthStart', this.dateStart)
        sessionStorage.setItem('monthEnd', this.dateEnd)
                                        
        this.$emit('getDates', { dateStart: this.dateStart, dateEnd: this.dateEnd});
        this.menu = false
      },
      allowedMonthsEnd(val) {
          return  new Date(val).toISOString().substr(0, 10) >= this.pickerDateStart
      },
      allowedMonthsStart(val) {
          return  new Date(val).toISOString().substr(0, 10) <= new Date().toISOString().substr(0, 10)
      },
  }
};
</script>

<style>
</style>